import { render, staticRenderFns } from "./GrupoNavigation.vue?vue&type=template&id=caba806a&"
import script from "./GrupoNavigation.vue?vue&type=script&lang=js&"
export * from "./GrupoNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports